function MFRPricingCalculator(index, element) {
  this.$element = $(element)

  this.selectors = {
    floorplanSelector: "#floorplan-select",
    addonsCheckbox: ".addons-checkbox",
    requiredOneTimeFees: ".required-onetime-fee",
    requiredRecurringFees: ".required-recurring-fee",
    selectedFloorPlanMainContainer: ".section-floorplan-selected",
    selectedFloorPlanEmptyContainer: ".section-floorplan-selected-empty",
    dynamicFloorPlanName: "#dynamic-floorplan-name",
    dynamicFloorPlanImage: "#dynamic-floorplan-image",
    dynamicFloorPlanPrice: "#dynamic-floorplan-price",
    dynamicFloorPlanAmenities: "#dynamic-floorplan-amenities",
    totalOneTimeContainer: "#total-onetime",
    totalRecurringContainer: "#total-recurring",
    allFeesMainContainer: ".section-floorplan-fees"
  }

  this.floorplansPayload = []

  this.states = {
    selectedFloorplanPrice: 0,
    oneTimeFees: 0,
    recurringFees: 0,
    finalTotal: 0
  }

  this.init()
}

MFRPricingCalculator.prototype = Object.assign({}, MFRPricingCalculator.prototype, {
  init: function () {
    this.$allFeesMainContainer = this.$element.find(this.selectors.allFeesMainContainer)
    this.$floorplanSelector = this.$element.find(this.selectors.floorplanSelector)
    this.$addonsCheckbox = this.$element.find(this.selectors.addonsCheckbox)

    this.$requiredOneTimeFees = this.$element.find(this.selectors.requiredOneTimeFees)
    this.$requiredRecurringFees = this.$element.find(this.selectors.requiredRecurringFees)

    this.$selectedFloorPlanMainContainer = this.$element.find(this.selectors.selectedFloorPlanMainContainer)
    this.$selectedFloorPlanEmptyContainer = this.$element.find(this.selectors.selectedFloorPlanEmptyContainer)

    this.$dynamicFloorPlanName = this.$element.find(this.selectors.dynamicFloorPlanName)
    this.$dynamicFloorPlanImage = this.$element.find(this.selectors.dynamicFloorPlanImage)
    this.$dynamicFloorPlanPrice = this.$element.find(this.selectors.dynamicFloorPlanPrice)
    this.$dynamicFloorPlanAmenities = this.$element.find(this.selectors.dynamicFloorPlanAmenities)

    this.$totalOneTimeContainer = this.$element.find(this.selectors.totalOneTimeContainer)
    this.$totalRecurringContainer = this.$element.find(this.selectors.totalRecurringContainer)

    $(window).on("load", this.__handleInitialization.bind(this))
    $(window).on("resize", this.__handleInitialization.bind(this))

    this.$floorplanSelector.on("change", this.__handleFloorplanSelection.bind(this))
    this.$addonsCheckbox.on("change", this.__handlePriceChange.bind(this))
  },

  __handleInitialization: function() {
    this.__handleGetEntrataJson()
    this.__handleInitOneTimeFees()
    this.__handleCalculateRecurringFees()
  },

  __handleGetEntrataJson: function() {
    const propertyNameFormatted = window.propertyData.name.replace(/\s+/g, '-').toLowerCase()

    $.ajax({
      url: `/wp-content/themes/alden-properties/local-json/${propertyNameFormatted}/entrata-data.json`,
      type: 'get',
      dataType: 'json',
      success: data => {
        this.floorplansPayload = data
      }
    })
  },

  __handleInitOneTimeFees: function() {
    let total = 0

    this.$requiredOneTimeFees.each(function() {
      total = total += parseFloat($(this).val())
    })

    this.__handleCalculateOneTimeFees(total)
    this.states.oneTimeFees = total
  },

  __handleCalculateOneTimeFees: function(value) {
    this.$totalOneTimeContainer.text(`$${value.toFixed(2)}`)
  },

  __handleCalculateRecurringFees: function() {
    let total = this.states.selectedFloorplanPrice

    this.$requiredRecurringFees.each(function() {
      total = total += parseFloat($(this).val())
    })

    this.$totalRecurringContainer.text(`$${total.toFixed(2)}`)
    this.states.recurringFees = total
  },

  __handleFloorplanSelection: function(e) {
    const floorplanEntrataId = Number(e.currentTarget.value)
    const getMatchFloorplan = this.floorplansPayload.response.result.FloorPlans.FloorPlan.filter(floorplan => floorplan.Identification.IDValue === floorplanEntrataId)

    if (getMatchFloorplan) {
      const name = getMatchFloorplan[0]?.Name,
            image = getMatchFloorplan[0]?.File[0]?.Src,
            price = getMatchFloorplan[0]?.MarketRent['@attributes']?.Max,
            beds = getMatchFloorplan[0]?.Room[0].Count,
            baths = getMatchFloorplan[0]?.Room[1].Count,
            sqft = getMatchFloorplan[0]?.SquareFeet?.['@attributes']?.Max

      const amenities = [
        beds ? `${beds} Beds` : null,
        baths ? `${baths} Baths` : null,
        sqft ? `${sqft} SQ FT` : null
      ].filter(Boolean).join(' | ')

      this.$selectedFloorPlanMainContainer.removeClass("hide")
      this.$selectedFloorPlanEmptyContainer.addClass("hide")

      this.$dynamicFloorPlanName.text(name)
      this.$dynamicFloorPlanImage.attr('src', image)
      this.$dynamicFloorPlanPrice.text(price)
      this.$dynamicFloorPlanAmenities.html(amenities)

      this.states.selectedFloorplanPrice = price
      this.__handleCalculateRecurringFees()
      this.$allFeesMainContainer.removeClass("disabled")
    }
  },

  __handlePriceChange: function(e) {
    const $target = $(e.currentTarget)
    const price = parseFloat($target.val())
    const isChecked = $target.is(":checked")
    
    let newRecurring = this.states.recurringFees
    let newOneTime = this.states.oneTimeFees

    // Handle autogroup logic
    if ($target.attr("data-autogroup") === "true" && !e.isTrigger) {
      const autogroupName = $target.attr("data-autogroup-sibling")
      const $siblings = this.$element.find(`input[type="checkbox"][data-autogroup-name='${autogroupName}']`)

      $siblings.prop("checked", isChecked).trigger("change", [true])
      $siblings.each((_, sibling) => {
        const $sibling = $(sibling)
        const siblingPrice = parseFloat($sibling.val())
        const siblingType = $sibling.attr("data-autogroup-type")

        if (siblingType === "onetime") {
          newOneTime += isChecked ? siblingPrice : -siblingPrice
        } else if (siblingType === "recurring") {
          newRecurring += isChecked ? siblingPrice : -siblingPrice
        }
      })
    }

    // Handle current checkbox
    const currentType = $target.attr("data-autogroup-type")
    if (currentType === "onetime") {
      newOneTime += isChecked ? price : -price
      this.states.oneTimeFees = newOneTime
      this.$totalOneTimeContainer.text(`$${newOneTime.toFixed(2)}`)
    } else {
      newRecurring += isChecked ? price : -price
    }

    this.states.recurringFees = newRecurring
    this.$totalRecurringContainer.text(`$${newRecurring.toFixed(2)}`)
  }
})